import appRouteEdit from "../../views/appRoutes/planningEdit.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("routeedit", {
    url: "routes/generate/:districtsQuery/",
    parent: "app",
    views: {
      view: {
        template: appRouteEdit,
      },
    },
    data: { title: "Route Edit" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/routeEdit/routeEdit.urls.js